module.exports = __webpack_public_path__ + "img/lead-12e.903ec0b5.png";